<div class="page-body" style="padding-bottom: 130px;">
    <img src="assets/imgs/cargo-info.png" width="1300">
</div>